module.exports = __webpack_public_path__ + "static/important-security-e1127035ab4cb5d7eaf2859ed15a9ab0.png";